export default "__VITE_ASSET__DPREh7z4__"